import React, { ReactElement } from 'react'
import { box, flex } from 'styled-system/patterns'

import { Icon } from '@mindfulchefuk/design-system/Icon'
import { ResetButton } from '@mindfulchefuk/design-system/Button'
import {
  NavSignInCTA,
  NavSignUpCTA,
} from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { unauthenticatedNav } from '@mindfulchefuk/features/Navigation/data'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { HomepageCTALocation } from '@mindfulchefuk/features/Homepage/components/CTA/types'
import { SignedOutNavMobile } from './SignedOutNavMobile/SignedOutNavMobile'
import { SignedOutNavDesktop } from './SignedOutNavDesktop'
import { useSignedOutNavMobileContext } from './context/SignedOutNavMobileContext'
import { SignedOutNavDesktopProvider } from './SignedOutNavDesktop/context/SignedOutNavDesktopContext'

type TSignedOutNav = {
  isOnboarding?: boolean
  variant: 'light' | 'dark'
  ctaLocation?: HomepageCTALocation
}

export const SignedOutNav = ({
  isOnboarding,
  variant,
  ctaLocation,
}: TSignedOutNav): ReactElement => {
  const { setIsHamburgerOpen } = useSignedOutNavMobileContext()

  const buttonVariant = variant === 'light' ? 'secondary' : 'secondary-white'

  return (
    <>
      <div
        className={box({
          order: -1,
          display: { xl: 'none' },
          pr: 4,
        })}
      >
        <ResetButton
          onClick={() => setIsHamburgerOpen(true)}
          data-testid="hamburger-button"
        >
          <Icon type="menu" size={32} />
        </ResetButton>
      </div>

      <SignedOutNavMobile links={unauthenticatedNav} />
      <SignedOutNavDesktopProvider>
        <SignedOutNavDesktop links={unauthenticatedNav} />
      </SignedOutNavDesktopProvider>

      <div
        className={flex({
          align: 'center',
          ml: 'auto',
        })}
      >
        <div
          className={box({
            display: { base: 'none', sm: 'block' },
            mr: { base: 3, lg: 4 },
          })}
        >
          <NavSignInCTA variant={buttonVariant} />
        </div>

        {!isOnboarding && (
          <NavSignUpCTA
            onClick={() =>
              trackAnalyticsEvent({
                name: `recipe CTA clicked`,
                data: {
                  'CTA location': ctaLocation,
                },
              })
            }
          />
        )}
      </div>
    </>
  )
}
